{
	"ariaClusterPhotos_one": "Cluster, {{count}} photo",
	"ariaClusterPhotos_other": "Cluster, {{count}} photos"
}
